import * as managers from 'app/mocks/data/park/managers/list'

import type { CategoryProduct } from 'app/types/catalogue/product/category'

export const category1: CategoryProduct = {
    id: 1,
    name: 'Desserts',
    client: managers.manager1,
    priority: 1,
}

export const category2: CategoryProduct = {
    id: 2,
    name: 'Boissons',
    client: managers.manager1,
    priority: 2,
}

export const category3: CategoryProduct = {
    id: 3,
    name: 'Fruits et Légumes',
    client: managers.manager1,
    priority: 3,
}

export const category4: CategoryProduct = {
    id: 4,
    name: 'Viandes',
    client: managers.manager1,
    priority: 4,
}

export const category5: CategoryProduct = {
    id: 5,
    name: 'Poissons',
    client: managers.manager1,
    priority: 5,
}

export const category6: CategoryProduct = {
    id: 6,
    name: 'Produits Laitiers',
    client: managers.manager1,
    priority: 6,
}

export const category7: CategoryProduct = {
    id: 7,
    name: 'Pain et Pâtisseries',
    client: managers.manager1,
    priority: 7,
}

export const category8: CategoryProduct = {
    id: 8,
    name: 'Épicerie Salée',
    client: managers.manager1,
    priority: 8,
}

export const category9: CategoryProduct = {
    id: 9,
    name: 'Épicerie Sucrée',
    client: managers.manager1,
    priority: 9,
}

export const category10: CategoryProduct = {
    id: 10,
    name: 'Surgelés',
    client: managers.manager1,
    priority: 10,
}

export const category11: CategoryProduct = {
    id: 11,
    name: 'Conserves',
    client: managers.manager2,
    priority: 1,
}

export const category12: CategoryProduct = {
    id: 12,
    name: 'Charcuterie',
    client: managers.manager2,
    priority: 2,
}

export const category13: CategoryProduct = {
    id: 13,
    name: 'Condiments',
    client: managers.manager2,
    priority: 3,
}

export const category14: CategoryProduct = {
    id: 14,
    name: 'Petit-déjeuner',
    client: managers.manager2,
    priority: 4,
}

export const category15: CategoryProduct = {
    id: 15,
    name: 'Snacks',
    client: managers.manager2,
    priority: 5,
}

export const category16: CategoryProduct = {
    id: 16,
    name: 'Plats Préparés',
    client: managers.manager3,
    priority: 1,
}

export const category17: CategoryProduct = {
    id: 17,
    name: 'Bio',
    client: managers.manager3,
    priority: 2,
}

export const category18: CategoryProduct = {
    id: 18,
    name: 'Sans Gluten',
    client: managers.manager3,
    priority: 3,
}

export const category19: CategoryProduct = {
    id: 19,
    name: 'Végétarien',
    client: managers.manager4,
    priority: 4,
}

export const category20: CategoryProduct = {
    id: 20,
    name: 'Huiles et Vinaigres',
    client: managers.manager4,
    priority: 5,
}

export const category21: CategoryProduct = {
    id: 21,
    name: 'Pâtes et Riz',
    client: managers.manager5,
    priority: 1,
}

export const category22: CategoryProduct = {
    id: 22,
    name: 'Céréales',
    client: managers.manager5,
    priority: 2,
}

export const category23: CategoryProduct = {
    id: 23,
    name: 'Sauces',
    client: managers.manager5,
    priority: 3,
}

export const category24: CategoryProduct = {
    id: 24,
    name: 'Produits du Monde',
    client: managers.manager5,
    priority: 4,
}

export const category25: CategoryProduct = {
    id: 25,
    name: 'Fromages',
    client: managers.manager5,
    priority: 5,
}

export const category26: CategoryProduct = {
    id: 26,
    name: 'Œufs',
    client: managers.manager6,
    priority: 1,
}

export const category27: CategoryProduct = {
    id: 27,
    name: 'Herbes et Épices',
    client: managers.manager6,
    priority: 2,
}

export const category28: CategoryProduct = {
    id: 28,
    name: 'Noix et Graines',
    client: managers.manager6,
    priority: 3,
}

export const category29: CategoryProduct = {
    id: 29,
    name: 'Confiserie',
    client: managers.manager6,
    priority: 4,
}

export const category30: CategoryProduct = {
    id: 30,
    name: 'Produits Festifs',
    client: managers.manager6,
    priority: 5,
}
